/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApplicationUserFromJSON, ApplicationUserToJSON, CarSeasonTireFromJSON, CarSeasonTireToJSON, TireDiameterDictionaryValueFromJSON, TireDiameterDictionaryValueToJSON, TireMakeDictionaryValueFromJSON, TireMakeDictionaryValueToJSON, TirePlacementFromJSON, TirePlacementToJSON, TireRatioDictionaryValueFromJSON, TireRatioDictionaryValueToJSON, TireWidthDictionaryValueFromJSON, TireWidthDictionaryValueToJSON, } from './';
export function CarTireFromJSON(json) {
    return CarTireFromJSONTyped(json, false);
}
export function CarTireFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'createdDate': !exists(json, 'createdDate') ? undefined : (new Date(json['createdDate'])),
        'modifiedDate': !exists(json, 'modifiedDate') ? undefined : (json['modifiedDate'] === null ? null : new Date(json['modifiedDate'])),
        'createdBy': !exists(json, 'createdBy') ? undefined : ApplicationUserFromJSON(json['createdBy']),
        'createdById': !exists(json, 'createdById') ? undefined : json['createdById'],
        'modifiedBy': !exists(json, 'modifiedBy') ? undefined : ApplicationUserFromJSON(json['modifiedBy']),
        'modifiedById': !exists(json, 'modifiedById') ? undefined : json['modifiedById'],
        'carSeasonTire': !exists(json, 'carSeasonTire') ? undefined : CarSeasonTireFromJSON(json['carSeasonTire']),
        'carSeasonTireId': !exists(json, 'carSeasonTireId') ? undefined : json['carSeasonTireId'],
        'tireMakeId': !exists(json, 'tireMakeId') ? undefined : json['tireMakeId'],
        'tireMake': !exists(json, 'tireMake') ? undefined : TireMakeDictionaryValueFromJSON(json['tireMake']),
        'tireDiameterId': !exists(json, 'tireDiameterId') ? undefined : json['tireDiameterId'],
        'tireDiameter': !exists(json, 'tireDiameter') ? undefined : TireDiameterDictionaryValueFromJSON(json['tireDiameter']),
        'tireRatioId': !exists(json, 'tireRatioId') ? undefined : json['tireRatioId'],
        'tireRatio': !exists(json, 'tireRatio') ? undefined : TireRatioDictionaryValueFromJSON(json['tireRatio']),
        'tireWidthId': !exists(json, 'tireWidthId') ? undefined : json['tireWidthId'],
        'tireWidth': !exists(json, 'tireWidth') ? undefined : TireWidthDictionaryValueFromJSON(json['tireWidth']),
        'productionYear': !exists(json, 'productionYear') ? undefined : json['productionYear'],
        'tirePlacement': !exists(json, 'tirePlacement') ? undefined : TirePlacementFromJSON(json['tirePlacement']),
    };
}
export function CarTireToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'createdBy': ApplicationUserToJSON(value.createdBy),
        'modifiedBy': ApplicationUserToJSON(value.modifiedBy),
        'carSeasonTire': CarSeasonTireToJSON(value.carSeasonTire),
        'carSeasonTireId': value.carSeasonTireId,
        'tireMakeId': value.tireMakeId,
        'tireMake': TireMakeDictionaryValueToJSON(value.tireMake),
        'tireDiameterId': value.tireDiameterId,
        'tireDiameter': TireDiameterDictionaryValueToJSON(value.tireDiameter),
        'tireRatioId': value.tireRatioId,
        'tireRatio': TireRatioDictionaryValueToJSON(value.tireRatio),
        'tireWidthId': value.tireWidthId,
        'tireWidth': TireWidthDictionaryValueToJSON(value.tireWidth),
        'productionYear': value.productionYear,
        'tirePlacement': TirePlacementToJSON(value.tirePlacement),
    };
}
